<template>
  <!-- 促销活动管理 -->
  <div class="promActivityList">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['促销管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd('', 'GZH', '', 1)"
          >新增组合活动
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd('', 'DZK', '', 1)"
          >新增折扣活动
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd('', 'DMJ', '', 1)"
          >新增满减活动
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd('', 'DMZ', '', 1)"
          >新增买赠活动
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd('', 'DHG', '', 1)"
          >新增换购活动
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd('', 'DQG', '', 1)"
          >新增抢购活动
        </el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-link
          @click="explain = true"
          style="margin-right: 10px"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >操作说明</el-link
        >
        <label class="label">活动类型：</label>
        <el-select
          v-model="searchForm.showType"
          placeholder="活动类型"
          style="width: 100px; margin-right: 5px"
          clearable
        >
          <el-option label="全部分类" value=""></el-option>
          <el-option label="换购" value="DHG"></el-option>
          <el-option label="买赠" value="DMZ"></el-option>
          <el-option label="折扣" value="DZK"></el-option>
          <el-option label="抢购" value="DQG"></el-option>
          <el-option label="满减" value="DMJ"></el-option>
          <el-option label="组合" value="GZH"></el-option>
        </el-select>
        <label class="label">活动状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="活动状态"
          style="width: 100px; margin-right: 5px"
          clearable
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="已上架" value="2"></el-option>
          <el-option label="未上架" value="1"></el-option>
          <el-option label="已删除" value="0"></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 150px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
        >
        </el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="entId"
        show-overflow-tooltip
        label="机构"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="id"
        show-overflow-tooltip
        label="活动编号"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="name"
        show-overflow-tooltip
        label="活动标题"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="typeName"
        show-overflow-tooltip
        label="活动类型"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="rule"
        show-overflow-tooltip
        label="规则标题"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | formatType">{{
            scope.row.status | formatStatus
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="160">
        <template slot-scope="scope">
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="
              handleAdd(
                scope.row.id,
                scope.row.type,
                scope.row.entId,
                scope.row.status
              )
            "
            v-show="scope.row.status != 0"
          >
            {{ scope.row.status == 1 ? "编辑" : "查看" }}
          </el-button>
          <el-button
            type="success"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 2)"
            v-show="scope.row.status == 1"
            >上架</el-button
          >
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 1)"
            v-show="scope.row.status == 2"
            >下架</el-button
          >
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 0)"
            v-show="scope.row.status == 1"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>该界面设置促销活动的开始时间和结束时间</p>
        <p>以组合活动为例：</p>
        <p>1、新增组合活动</p>
        <p>2、设置活动名称</p>
        <p>3、设置开始时间</p>
        <p>4、设置结束时间</p>
        <p>5、选择<span style="font-weight: bold">上架</span>的促销活动</p>
        <p>6、保存</p>
        <p>7、上架</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//混入
import { formatStatus } from "@/mixins/filters/formatStatus.js";

export default {
  name: "promActivityList",
  mixins: [formatStatus],
  data() {
    return {
      /**表格数据 */
      // {
      //   entId:"机构",
      //   id:"活动编号",
      //   name:"活动标题",
      //   typeName:"活动类型名称",
      //   type:"活动类型",
      //   rule:"规则标题",
      //   status:"状态",
      // }
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      selectedList: [],
      /**搜索表单 */
      searchForm: {
        showType: "", // 方案类型
        status: "", // 方案状态
        name: "",
      },

      /**使用说明 */
      explain: false,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      var data = {
        type: "QueryList",
        status: this.searchForm.status,
        faType: this.searchForm.showType,
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      this.$requestSys({
        url:
          "prom/ashx/PromSalesList.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)),
        method: "post",
      })
        .then((res) => {
          console.log(res);
          this.allPage = res.recordCount;
          this.tableData = [];
          if (res.flag == 0) {
            for (let i = 0; i < res.data.length; i++) {
              this.tableData.push({
                entId: res.data[i].entid,
                id: res.data[i].salesCode,
                name: res.data[i].salesName,
                type: res.data[i].faType,
                typeName: res.data[i].faName,
                rule: res.data[i].ruleTitle,
                remarks: res.data[i].describe,
                status: res.data[i].isShow,
              });
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**点击新增/编辑 */
    handleAdd(id, type, entid, status) {
      let prams = encodeURIComponent(
        JSON.stringify({ id, type, entid, status })
      );
      this.$router.push({
        path: "addPromActivity",
        query: {
          prams: prams,
        },
      });
    },
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let msgType = "info";
      let type = "UpdateSalesShow";
      if (status == 2) {
        msg = "确定上架吗?";
        msgType = "success";
        type = "UpdateSalesShow";
      } else if (status == 1) {
        msg = "确定下架吗?";
        msgType = "warning";
        type = "UpdateSalesDown";
      } else if (status == 0) {
        msg = "确定删除吗?";
        msgType = "error";
        type = "DeleteSales";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: msgType,
      })
        .then(() => {
          let data = {
            type: type,
            ruleCode: row.id,
            entid: row.entId,
          };
          this.$requestSys({
            url:
              "prom/ashx/PromSalesList.ashx?json=" +
              encodeURIComponent(JSON.stringify(data)),
            method: "post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.promActivityList {
  width: 100%;
  height: 100%;
}
</style>
